"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _registerI18nTranslations = _interopRequireDefault(require("./registerI18nTranslations"));

var _registerNumberFormatting = _interopRequireDefault(require("./registerNumberFormatting"));

var _registerMoment = _interopRequireDefault(require("./registerMoment"));

var _default = function _default(Provider) {
  var validPromise = window.Q ? window.Q.Promise : Promise;
  return validPromise.all([(0, _registerI18nTranslations.default)(Provider), (0, _registerNumberFormatting.default)(Provider), (0, _registerMoment.default)(Provider)]);
};

exports.default = _default;
module.exports = exports.default;